import Api from 'libs/api/index';

class VacancyApplicationTypesApi extends Api {
  constructor() {
    super('cv/vacancy_application_types/');
  }
}

export default VacancyApplicationTypesApi;
